/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import BackButton from '../../../../components/BackButton'
import CustomCheckbox from '../../../../components/CustomCheckbox/CustomCheckbox'
import Title from '../../../../components/Title/Title'
import '../../../style.css'
import CustomValidater from '../../../../components/Utility/Validater'

const ModulesComponent = (props) => {
    const user = useSelector((state) => state.auth)
    let userData = {}
    const { isEdit, title, record } = props
    if (isEdit) userData = { modified_by: user.description }
    else
        userData = {
            created_by: user.description,
            modified_by: user.description,
        }

    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>

            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Prefix"
                    source="prefix"
                    validate={required()}
                />
                <div
                    style={{
                        display: 'flex',
                        flex: 0.3,
                    }}
                >
                    <CustomCheckbox label="Display" source="is_display" />
                </div>
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
        </SimpleForm>
    )
}

export default function CreateModules(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    console.log('moduless', props)
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/SS_ModuleTAB')
        refresh()
    }
    if (isEdit)
        return (
            <>
                <BackButton path="/SS_ModuleTAB" />
                <Edit {...props} undoable={false}>
                    <ModulesComponent title="Edit Modules" isEdit />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/SS_ModuleTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <ModulesComponent title="Create Modules" isEdit={false} />
            </Create>
        </>
    )
}

CreateModules.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

ModulesComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    editPress: PropTypes.func.isRequired,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
